export const FETCH_TAGS = '/v1/tags';
export const CREATE_TAGS = '/v1/tags';
export const FETCH_CAMPAIGNS = '/campaign/all';
export const PLUGINS = '/v1/plugins';
export const DELETE_CAMPAIGN_RESPONSE = '/v1/campaign-responses';
export const MEDIA = '/v1/media';
export const ATTACHMENT = '/v1/attachments';
export const GENERATE_IMAGE_PRESIGNED_URL = '/v1/campaign-elements/image/presign';
export const GET_APP_SUMO_CODES = '/appsumo/appsumocodes';
export const DOWNLOAD = '/v1/downloads';
export const PLUGIN_OPTIONS = '/v1/options/plugin-styles';
export const API_KEYS = '/v1/accounts/api-key';
export const GET_CAMPAIGNS = '/v1/campaigns';
export const CAMPAIGN_TEMPLATES = '/v1/campaign-templates';
export const CAMPAIGN_TEMPLATES_TYPE = '/v1/campaign-templates/type';
export const FEATURES = '/v1/features';
export const FEATURES_ORG = '/v1/features/organization';
export const FETCH_CLIENTS = '/user/all/';
export const FEATURE_DATA = '/v1/features';
export const VIDEO_COMPILATION = '/v1/video-compilation';



// WEBPACK FOOTER //
// ./src/constants/endpoints.js